<template>
  <div id="App">
    <van-nav-bar
      :title="title"
    />
    <Logo></Logo>
    <van-row type="flex">
      <van-col span="2"></van-col>
      <van-col span="20">
        <van-field label="1.退出后将无法查看项目信息" label-width="100%" label-align="center" />
        <van-field label="2.退出后可以重新登录其它账号" label-width="100%" label-align="center"  />
        <van-field label="3.如有疑问请致电服务热线" label-width="100%" label-align="center"/>
        <van-field label="服务热线：0573-86337050" label-width="100%" label-align="center" style="margin-bottom: 15px" size="large" />
      </van-col>
      <van-col span="2"></van-col>
    </van-row>
    <van-row gutter="20">
      <van-col span="2"></van-col>
      <van-col span="20">
        <van-button round block type="danger" @click="onLoginOut()">
          {{title}}
        </van-button>
      </van-col>
      <van-col span="2"></van-col> 
    </van-row>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Tabbar from '@/components/Tabbar.vue'
import Logo from '@/components/Logo.vue'
import { Dialog } from 'vant';
export default {
  data () {
    return {
      title: '退出/解除绑定',
      userInfoOut: {
          userName: '',
          userCardID: '',
          loginType: 0,
          token: '',
          wechatUserCode: ''
      },
      tempPro: {
          Code: '',
          Name: '',
      },
      tempTeam: {
          Code: '',
          Name: '',
      },
      tempDayActive: 1
    }
  },
  components: {
    Tabbar,
    Logo
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    onLoginOut () {
      var that = this
      if(that.userInfo.wechatUserCode == "")
      {
        that.$store.commit('setUserInfo', that.userInfoOut)
        that.$store.commit('setTempPro', that.tempPro)
        that.$store.commit('setTempTeam', that.tempTeam)
        that.$store.commit('setTempDayActive', that.tempDayActive)
        that.$router.push('/')
      }
      else
      {
        that.$axios({
        method:"post",
        url:"/api/Main",
        data:{
          Method:"GetWechatLoginOut",
          Params:[
              that.userInfo.wechatUserCode
          ]
        },
        headers:{
          'Authorization': 'Bearer ' + that.userInfo.token
        }
        })
        .then((response)=>{
            if(response.data.status == "200")
            {
              that.$store.commit('setUserInfo', that.userInfoOut)
              that.$store.commit('setTempPro', that.tempPro)
              that.$store.commit('setTempTeam', that.tempTeam)
              that.$store.commit('setTempDayActive', that.tempDayActive)
              that.$router.push('/')
            }
            else
            {
              Dialog({ message: response.data.msg })
            }
        })
        .catch(error => {
            console.log(error);
            Dialog({ message: error.message })
        })
      }
    }
  }
}
</script>
